const getters = {
  gettersToken: state => state.user.token,
  gettersRouteFlag: state => state.user.routeFlag,
}
export default getters
